var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.gotPackageData)?_c('v-main',[_c('router-view')],1):_vm._e(),_c('loading-screen'),_c('stage-navigator')],1)}
var staticRenderFns = []

export { render, staticRenderFns }